/* eslint-disable */
import { v4 as uuid4 } from "uuid";
import axios from "axios";
import { buildS3MediaUrl } from "./s3UrlHelpers";

const UPLOAD_TIMEOUT_MS = 60_000;

// Keep in sync with ALLOWED_CONTENT_TYPE in presign.js
const ALLOWED_CONTENT_TYPE = /^(image\/(png|jpeg|gif|webp)|video\/[\w.+-]+|application\/pdf)$/;

export const sendPhotoToS3 = async (file: File) => {
  try {
    if (!file.type || !ALLOWED_CONTENT_TYPE.test(file.type)) {
      throw new Error(`Unsupported file type: ${file.type || "unknown"}`);
    }

    const fileType = file.type.split("/")[1];
    const fileName = `${uuid4()}.${fileType}`;

    // Relative URL — hits Express directly, not the Django proxy
    const presignResponse = await axios.post(
      "/api/generate-presigned-urls",
      { files: [{ id: fileName, file_name: fileName, file_type: file.type }] },
      { timeout: UPLOAD_TIMEOUT_MS }
    );

    const signedUrl =
      presignResponse.data?.message?.files?.[0]?.presigned_upload_url;
    if (!signedUrl) {
      throw new Error("No presigned URL returned from server");
    }

    await axios.put(signedUrl, file, {
      headers: { "Content-Type": file.type },
      timeout: UPLOAD_TIMEOUT_MS,
    });

    const completePhotoUrl = buildS3MediaUrl(fileName);

    return { fileName, fileUrl: completePhotoUrl };
  } catch (e) {
    console.error("Upload failed", e);
    return { fileName: "", fileUrl: "" };
  }
};
